module.exports = __webpack_public_path__ + "static/media/error_501.f42475db.png";